<template>
    <div>
        <base-form-plus :isAdd="formInfo.isAdd" :relationDialogVisible.sync="formInfo.dialogVisible" showTitle="通知中心"
                  :showData="formInfo.editData"
                  :rules="rules" @submitAdd="submitAdd" @submitEdit="submitEdit" ref="baseForm" defaultEmpty>
            <template v-slot:default="{ruleForm}" class="info">
                        <el-form-item :label="columnInfo.type.label" prop="type">
                                <enum-dict-select v-model="ruleForm.type" placeholder="请选择" dict-code="notificationType" module-name="system" clearable></enum-dict-select>
                        </el-form-item>
                        <el-form-item :label="columnInfo.priority.label" prop="priority">
                                <enum-dict-select v-model="ruleForm.priority" placeholder="请选择" dict-code="notificationPriority" module-name="system" clearable></enum-dict-select>
                        </el-form-item>
                        <el-form-item :label="columnInfo.category.label" prop="category">
                                <el-input v-model="ruleForm.category" placeholder="请输入业务分类"></el-input>
                        </el-form-item>
                        <el-form-item :label="columnInfo.title.label" prop="title">
                                <el-input v-model="ruleForm.title" placeholder="请输入通知标题"></el-input>
                        </el-form-item>
                        <el-form-item label="接收用户" prop="userIds">
                                <multi-user-input v-model="ruleForm.userIds" placeholder="请选择接收用户"></multi-user-input>
                        </el-form-item>
                        <el-form-item label="跳转URL" prop="jumpUrl">
                                <el-input v-model="ruleForm.jumpUrl" placeholder="请输入跳转URL"></el-input>
                        </el-form-item>
                        <el-form-item label="回执URL" prop="receiptUrl">
                                <el-input v-model="ruleForm.receiptUrl" placeholder="请输入回执URL"></el-input>
                        </el-form-item>
                        <el-form-item :label="columnInfo.title.label" prop="content">
                                <el-input type="textarea" :rows="6" v-model="ruleForm.content" placeholder="请输入通知内容（支持富文本）"></el-input>
                        </el-form-item>
            </template>
        </base-form-plus>
    </div>
</template>

<script>
    import {mapState, mapMutations, mapActions} from "vuex";
    import MultiUserInput from "@/components/widget/MultiUserInput";

    export default {
        name: 'NotificationForm',
        components: {
            MultiUserInput
        },
        computed: {
            ...mapState({
                rules: state => state.system.notification.rules,
                tableData: state => state.system.notification.tableData,
                formInfo: state => state.system.notification.formInfo,
                options: state => state.system.notification.options,
                columnInfo: state => state.system.notification.columnInfo,
            })
        },
        data() {
          return {
          }
        },
        methods: {
            ...mapMutations({
                setDialogVisible: 'system/notification/setDialogVisible',
            }),
            ...mapActions({
                submitAdd: 'system/notification/submitAdd',
                submitEdit: 'system/notification/submitEdit',
            })
        }
    }
</script>

<style lang="less" scoped>
    .info {
        display: flex;
        flex-wrap: wrap;

        .el-form-item {
            width: 50%;
        }
    }
</style>
